import { render } from "./InitialAgreement.vue?vue&type=template&id=f10e2da0"
import script from "./InitialAgreement.vue?vue&type=script&lang=js"
export * from "./InitialAgreement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v1/InitialAgreement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f10e2da0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f10e2da0', __exports__)) {
    api.reload('f10e2da0', __exports__)
  }
  
  module.hot.accept("./InitialAgreement.vue?vue&type=template&id=f10e2da0", () => {
    api.rerender('f10e2da0', render)
  })

}


export default __exports__